import { get } from 'lodash';
import {
  selectNutritionProgram,
  selectNutritionPrograms,
  selectNutritionProgramIdForBmi,
} from 'logic/nutritionPrograms';

export const ProfileFieldsNutrition = {
  bindings: {
    form: '<',
    member: '<',
    isEditing: '<',
    questions: '<',
    onUpdate: '&',
  },

  template: `
    <div class="row">
      <div class="col-md-4">
        <h5>Nutrition</h5>
        <p>
          Select your Nutrition Profile. Your recipes will be tailored to
          match your settings.
        </p>
      </div>
      <div class="col-md-8">
        <div ng-hide="$ctrl.isEditing">
          <form-group-row>
            <form-group-left>
              <form-label>
                Calorie Level
              </form-label>
            </form-group-left>
            <form-group-right>
              <div class="col-form-label pb-0">
                {{ $ctrl.currentTitle }}
              </div>
            </form-group-right>
          </form-group-row>
          <hr>
          <form-group-row>
            <form-group-left>
              <form-label>
                Are you vegetarian?
              </form-label>
            </form-group-left>
            <form-group-right>
              <div class="col-form-label pb-0"
                ng-switch="$ctrl.member.profile.vegetarian">
                <span ng-switch-when="true">Yes, I'm vegetarian</span>
                <span ng-switch-when="false">No, I'm not vegetarian</span>
              </div>
            </form-group-right>
          </form-group-row>
          <div ng-repeat="item in $ctrl.questions track by $index">
            <hr>
            <form-group-row>
              <form-group-left>
                <form-label>
                  {{ item.label }}
                </form-label>
              </form-group-left>
              <form-group-right>
                <div class="col-form-label pb-0">
                  {{ item.answer }}
                </div>
              </form-group-right>
            </form-group-row>
          </div>
        </div>
        <div ng-show="$ctrl.isEditing">
          <div class="form-group">
            <form-label for="goal">
              What best describes you?
            </form-label>
            <form-radio-list
              form="$ctrl.form"
              name="goal"
              value="$ctrl.currentGoal"
              list="$ctrl.nutrition.goals"
              list-item-key="goal"
              list-item-title="goal"
              list-item-class="list-inline-item col-md-6"
              on-update="$ctrl.onClick(key, value)">
            </form-radio-list>
          </div>
          <hr>
          <div class="form-group">
            <form-label for="level">
              Calorie Level
            </form-label>
            <div ng-if="$ctrl.isEditing" nutrition-bmi="$ctrl.member.bmi"></div>
            <form-radio-list
              form="$ctrl.form"
              list="$ctrl.nutrition.programs"
              name="nutritionProgramId"
              key="voomeProfile.nutritionProgramId"
              value="$ctrl.member.voomeProfile.nutritionProgramId"
              list-item-key="id"
              list-item-title="title"
              list-item-class="list-inline-item col-md-6"
              is-disabled="!$ctrl.member.voomeProfile.nutritionProgramId"
              on-update="$ctrl.onUpdate({ key: key, value: value })"
              required="true">
            </form-radio-list>
          </div>
          <p class="px-2"
            ng-repeat="item in $ctrl.nutrition.programs track by $index"
            ng-if="item.id == $ctrl.member.voomeProfile.nutritionProgramId">
            {{ item.description }}
          <p>
          <hr>
          <div class="form-group">
            <form-label for="vegetarian">
              Are you vegetarian?
              <span class="text-gray pl-3"
                ng-switch="$ctrl.member.profile.vegetarian"
                ng-hide="$ctrl.isEditing">
                <span ng-switch-when="true">Yes, I'm vegetarian</span>
                <span ng-switch-when="false">No, I'm not vegetarian</span>
              </span>
            </form-label>
            <span class="d-block d-sm-inline pl-sm-3">
              <span class="mx-2">
                <form-radio
                  form="$ctrl.form"
                  model="$ctrl.member.profile.vegetarian"
                  key="profile.vegetarian"
                  value="true"
                  on-update="$ctrl.onUpdate({ key: key, value: value })">
                  Yes
                </form-radio>
              </span>
              <span class="mx-2">
                <form-radio
                  form="$ctrl.form"
                  model="$ctrl.member.profile.vegetarian"
                  key="profile.vegetarian"
                  value="false"
                  on-update="$ctrl.onUpdate({ key: key, value: value })">
                  No
                </form-radio>
              </span>
            </span>
          </div>
          <hr>
          <div class="form-group"
            ng-repeat="item in $ctrl.questions track by $index">
            <form-label>
              {{ item.question }}
            </form-label>
            <form-fieldset
              form="$ctrl.form"
              key="voomeProfile.preferences.{{ item.key }}"
              list="$ctrl.member.voomeProfile.preferences[item.key]"
              type="{{ item.type }}"
              on-update="$ctrl.onUpdate({ key: key, value: value })">
            </form-fieldset>
          </div>
        </div>
      </div>
    </div>`,

  controller() {
    return {
      $onInit() {
        if (this.member) {
          const id = this.member.voomeProfile.nutritionProgramId;

          if (id) {
            this.currentTitle = selectNutritionProgram({ id }).title;
          }

          this.nutrition = selectNutritionPrograms(
            this.member.profile.gender,
            this.currentGoal
          );
        }
      },

      onClick(key, goal) {
        const { bmi } = this.member;
        const { gender } = this.member.profile;
        const current = selectNutritionProgram({ goal, gender });

        this.currentGoal = current.goal;
        this.currentTitle = current.title;
        this.currentLevel = current.level;

        this.onUpdate({
          key: 'voomeProfile.nutritionProgramId',
          value: selectNutritionProgramIdForBmi(current.id, bmi),
        });
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileFieldsNutrition.js